import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";

const images = [
  "./img/restaurace/restaurace-1.jpg",
  "./img/restaurace/restaurace-2.jpg",
  "./img/restaurace/restaurace-6.jpg",
  "./img/restaurace/restaurace-4.jpg",
  "./img/restaurace/restaurace-3.jpg",
  "./img/restaurace/restaurace-5.jpg",
  "./img/restaurace/restaurace-7.jpg",
  "./img/restaurace/restaurace-1.jpg",
  "./img/restaurace/restaurace-2.jpg",
];

const FotogalerieRestaurace: React.FC = () => {
  return (
    <>
      {/* ================= HEAD ================= */}
      <Helmet>
        <title>Restaurace & interiér | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Fotogalerie restaurace a interiéru Hospůdky pod Rablinů."
        />
      </Helmet>

      {/* ================= NAVBAR (IZOLACE) ================= */}
      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      {/* ================= OBSAH ================= */}
      <main className="bg-[#F5E7CC] text-[#32180d] overflow-x-hidden">

        {/* ================= NADPIS ================= */}
        <section className="bg-white py-20 text-center">
          <h1 className="text-3xl md:text-4xl font-bold font-serif">
            RESTAURACE & INTERIÉR
          </h1>
        </section>

        {/* ================= GALERIE ================= */}
        <section className="max-w-7xl mx-auto px-6 py-20">
          <div
            className="
              grid
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-3
              gap-6
            "
          >
            {images.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Restaurace ${i + 1}`}
                className="
                  w-full
                  h-64
                  object-cover
                  rounded-xl
                  shadow-md
                  hover:scale-[1.02]
                  transition-transform
                  duration-300
                "
              />
            ))}
          </div>
        </section>

        {/* ================= FOOTER (ABSOLUTNÍ RESET) ================= */}
        <div className="[all:unset] block">
          <Footer />
        </div>

      </main>
    </>
  );
};

export default FotogalerieRestaurace;